<template>
    <div>
        <div class="app-block p-md">
            <transition name="component-fade" mode="out-in">
                <div>

                    <h3 class="heading-line has-text-centered">
                        <span class="title" v-model="page.title">Procédure d’admission</span>
                    </h3>

                    <div class="has-background-white-ter p-md" v-if="page.body.warning" v-html="page.body.warning">
                    </div>


                    <div class="app-block m-t-md  p-md" v-html="page.body.intro">
                    </div>


                    <div class="app-block p-md m-t-md" v-html="page.body.stepA">
                    </div>

                    <div class="app-block p-md m-t-md" v-html="page.body.stepB">
                    </div>

                    <div class="app-block p-md m-t-md" v-html="page.body.stepC">
                    </div>

                    <div class="app-block p-md m-t-md" v-html="page.body.stepD">
                    </div>

                    <div class="app-block p-md m-t-md" v-html="page.body.stepE">
                    </div>

                    <div class="app-block p-md m-t-md" v-html="page.body.stepF">
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import api from 'services/organization'

    export default {
        data () {
            return {
                page: {
                    id: 2,
                    title: 'Procédure d’admission',
                    body: {}
                }
            }
        },
        methods: {},
        created () {
            let page = 1
            if (this.$route.meta.schoolType === 'boardingschool') {
                page = 2
            }
            if (this.$route.meta.schoolType === 'eschool') {
                page = 6
            }
            api.page(page).then((result) => {
                this.page.body = JSON.parse(result.data.body)
            }).catch((err) => {
                this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
            })
        }
    }
</script>

<style>

    .dock {
        z-index: 15000 !important;
    }

    .picture-input {
        z-index: 5 !important;
    }

    p {
        margin: 0;
    }

    .ql-align-left {
        text-align: left;
    }

    .ql-align-center {
        text-align: center;
    }

    .ql-align-right {
        text-align: right;
    }
</style>
